import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home/Home.vue';
import Aboutus from '../views/Aboutus/Aboutus.vue';
import Linkus from '../views/Linkus/Linkus.vue';
import Leadercare from '../views/Leadercare/Leadercare.vue';
import Grouphonor from '../views/Grouphonor/Grouphonor.vue';
import Milestone from '../views/Milestone/Milestone.vue';
import Newscenter from '../views/Newscenter/Newscenter.vue';
import Newscontent from '../views/Newscontent/Newscontent.vue';
import Prodoctsec from '../views/Prodoctsec/Prodoctsec.vue';
import Prodoctthird from '../views/Prodoctthird/Prodoctthird.vue';
import Qualityserve from '../views/Qualityserve/Qualityserve.vue';
import Companycultrue from '../views/Companycultrue/Companycultrue.vue';
import Videopublicity from '../views/Videopublicity/Videopublicity.vue';
import Prodoctfour from '../views/Prodoctfour/Prodoctfour.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/Aboutus',
		name: 'Aboutus',
		component: Aboutus
	},
	{
		path: '/Linkus',
		name: 'Linkus',
		component: Linkus
	},
	{
		path: '/Leadercare',
		name: 'Leadercare',
		component: Leadercare
	},
	{
		path: '/Grouphonor',
		name: 'Grouphonor',
		component: Grouphonor
	},
	{
		path: '/Milestone',
		name: 'Milestone',
		component: Milestone
	},
	{
		path: '/Newscenter',
		name: 'Newscenter',
		component: Newscenter
	},
	{
		path: '/Newscontent',
		name: 'Newscontent',
		component: Newscontent
	},
	{
		path: '/Prodoctsec',
		name: 'Prodoctsec',
		component: Prodoctsec
	},
	{
		path: '/Prodoctthird',
		name: 'Prodoctthird',
		component: Prodoctthird
	},
	{
		path: '/Qualityserve',
		name: 'Qualityserve',
		component: Qualityserve
	},
	{
		path: '/Companycultrue',
		name: 'Companycultrue',
		component: Companycultrue
	},
	{
		path: '/Videopublicity',
		name: 'Videopublicity',
		component: Videopublicity
	},
	{
		path: '/Prodoctfour',
		name: 'Prodoctfour',
		component: Prodoctfour
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

router.beforeEach((to, from, next) => {
	document.body.scrollTop = 0;
	next();
});

export default router;
